export default "__VITE_ASSET__a094a095__"